// extracted by mini-css-extract-plugin
export default {"box":"Slider_box__vzvWG","boxContent":"Slider_boxContent__X3CUN","contentDiv":"Slider_contentDiv__1eGDT","credit":"Slider_credit__A9nbw"};